import Image from 'next/image';
import React from 'react';
import clsx from 'clsx';

export const FeatureRightImgSection = ({
  imgSrc,
  imgAlt,
  title,
  textStructure,
}) => {
  return (
    <section className="w-full max-w-screen-xl mx-auto mt-[60px] pb-[24px]">
      <div className="flex flex-col justify-center items-center mx-[4px] mt-[10px] lg:mt-0 lg:grid lg:grid-cols-2 lg:mx-auto">
        <div className="shadow-darkRed h-full max-w-260 md:max-w-80 md:h-80 relative overflow-hidden rounded-[16px] !my-2 md:!mb-0 lg:hidden">
          <img
            width={300}
            height={428}
            src={imgSrc}
            alt={imgAlt}
            className={clsx(
              'lg:hidden',
              'h-full max-w-[576px]',
              'rounded-[12px]',
            )}
          />
        </div>
        <div className="text-center md:text-start m-5">
          <h2 className="font-bold">{title}</h2>
          <div className="text-wtf-white text-xs">{textStructure}</div>
        </div>
        <div
          className={clsx(
            'flex-[1] basis-1/3',
            'max-w-[828px]',
            'hidden lg:!flex lg:!flex-row lg:!justify-center lg:!items-center',
          )}
        >
          <img
            src={imgSrc}
            alt={imgAlt}
            width={428}
            height={428}
            className="rounded-[12px]"
          />
        </div>
      </div>
    </section>
  );
};
